<template>
  <div
    v-if="activesubsciption.length > 0"
    class="billing-wrapper"
  >
    <div class="heading">
      Plan and Billing
    </div>
    <div class="sub-head">
      Change or update your {{ activesubsciption[0].plan.metadata.name }} and
      keep track of billing settings
    </div>
    <div class="show_details">
      <div>
        <div
          v-for="active in activesubsciption"
          :key="active"
          class="plan-container"
        >
          <div class="plan-type">
            <div class="plan-name">
              {{ active.plan.metadata.name }} 
            </div>
            <div class="cost inter-normal-storm-gray-12px">
              {{ active.plan.amount / 100 }} Euro
            </div>
            <div
              class="plan-details inter-normal-mountain-meadow-12px"
              @click="showPlanDetails"
            >
              <span v-if="!showPlan">See Plan Details</span>
              <span v-else>Hide Plan Details</span>
            </div>
          </div>
          <div class="plan-update">
            <div class="plan-end">
              Renewal date:
              <span>{{ new Date(active.current_period_end * 1000).toUTCString() }}
              </span>
            </div>
            <button
              type="button"
              class="renew"
              @click="cancelPlan(active.id)"
            >
              Cancel Plan
            </button>
          </div>
        </div>
        <payment-settings />
      </div>
      <plan-details
        v-if="showPlan && activesubsciption.length > 0"
        :plan="activesubsciption[0].plan"
      />
    </div>
    <teleport to="body">
      <div
        v-if="loader"
        class="loading_log"
      >
        <spin-loading
          loadingstatus=""
          loadingmessage=""
        />
      </div>
    </teleport>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import SpinLoading from '../SpinLoading'
import PaymentSettings from './PaymentSettings.vue';
import PlanDetails from './PlanDetails.vue';
export default {
  components: { PaymentSettings, PlanDetails,SpinLoading },
  data() {
    return {
      activesubsciption: [],
      loader: false,
      showPlan:true
    };
  },
  computed: {
    ...mapGetters({ subscriptionList: 'subscription/subscriptionList' }),
  },
  methods: {
    ...mapActions({
      listsubscription: 'subscription/listsubscription',
      cancelSubscription: 'subscription/cancelSubscription',
    }),
    showPlanDetails(){
      this.showPlan=!this.showPlan
    },

    async cancelPlan(id) {
      this.loader = true;

      let isCancelled = await this.cancelSubscription({
        subscriptionId: id,
      });

      if (isCancelled) {
        let list = await this.listsubscription();
        if (list) {
          this.activesubsciption = this.subscriptionList.data;
        }
      }
      this.loader = false;

      if(this.activesubsciption.length === 0){
        await this.$alert(
          'Please go to the pricing section and get one plan',
          'No Active Subscription',
          'info',
        )
        this.$router.push('/pricing/details')
      }
    },
  },

  async created() {
    try{
      this.loader = true;
      let list = await this.listsubscription();
      if (list) {
        this.activesubsciption = this.subscriptionList.data;
      }else{
        throw 'Error fetching subscription'
      }
      if(this.activesubsciption.length === 0){
        this.$router.push('/pricing/details')
      }
    }catch{
      this.$alert(
        'Error retrieving the account summary, please refresh the page',
        'Error',
        'error',
      )
    }finally{
      this.loader = false;
    }
  },
};
</script>

<style scoped>
.show_details {
  display: flex;
  justify-content: space-between;
}
.sub-head-cancelled-subscription {
  position: absolute;
  left: 50%;
  border: 1px solid var(--djuli-tertiary-color);
  background: var(--djuli-tertiary-color);
  color: white;
  padding: 0.25rem;
  border-radius: 4px;
  top: 4rem;
}
.billing-wrapper {
 

  padding: 1rem;
  
  position: relative;
  /* box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.12); */
}
.heading {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  color: #0f172a;
  padding-bottom: 8px;
  margin-top: 1.5rem;
}
.sub-head {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #334155;
  padding-bottom: 66px;
}
.djuli-logo {
  padding-bottom: 1rem;
}
.logo {
  padding-right: 4px;
}
.plan-container {
  display: flex;
  align-items: flex-end;
  padding-bottom: 10rem;
}
.plan-details {
  cursor: pointer;
}
.plan-name {
  padding-bottom: 8px;
  font-family: Inter;
  font-weight: 600;
  font-size: 19px;
  color: #0f172a;
}
.cost {
  padding-bottom: 0.25rem;
}
.card-info {
  font-family: Inter;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 0.02em;
  color: #334155;
  padding-bottom: 0.25rem;
}
.plan-end {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #334155;
  padding-right: 1rem;
}
.plan-end > span {
  color: #ef4444;
}
.renew {
  width: 92px;
  height: 34px;
  background: var(--djuli-primary-color);
  border-radius: 5px;
  cursor: pointer;
  border: none;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  text-align: center;
  color: #f8fafc;
}
.plan-update {
  display: flex;
  align-items: center;
  padding: 8px;
  width: 406px;
  height: 50px;
  background: #f8fafc;
  border-radius: 4px;
}
.plan-type {
  width: 200px;
}
</style>
